import Logger from 'Logger'

import { popShow } from '../../../manager/mall.event'

/**
 * 선물 상품 구매 불가시 예외 팝업 호출
 * @param {Response} response
 * @param {Boolean} templateName
 */
export function giftGuard(response, templateName) {
  if (!templateName === 'gift') return false

  Logger.info('[GIFT_CONTROLLER]')

  var res = response.result
  var isGiftBlock =
    res.present_block_info && res.present_block_info.is_present_block
  var GiftBlockInfo = isGiftBlock && res.present_block_info.ret_url
  if (isGiftBlock) {
    popShow({
      title: '선물하기 불가',
      message:
        '선물하기 제한 설정으로 선물을 할 수 없습니다. <br  /> <span>마이피망 &gt; 보안설정에서 본인확인 후 해제 할 수 있습니다.</span>',
      confirmText: '보안설정 보기',
      confirmBtnColor: 'gray',
      onClose: function () {
        this.hide()
      },
      onConfirm: function () {
        window.open(GiftBlockInfo || 'https://account.pmang.com/', '_blank')
      },
    })
    throw new Error('선물 불가!')
  }
}
